
// =====================================================================
// Class to convert any adminstrative bounds data to other forms
// e.g. if you have a state ID, and want to index another table by state NAME
// =====================================================================

import listOfAllPossibleLayers from '../content/list-of-all-possible-layers-and-their-info/list-of-all-possible-layers-and-their-info'
import statesGeoData from '../content/state-geo-data'

class AdminBoundsDataManager {
	constructor() {
		this._layerFields = {}
		listOfAllPossibleLayers.LIST_OF_ALL_POSSIBLE_LAYERS.forEach(layer => {
			this._layerFields[layer.cartoId] = {
				state_id: layer.fieldStateId,
				state_name: layer.fieldStateName
			}
		})

		this._fipsLookup = {}
		statesGeoData.states.forEach(s => {
			this._fipsLookup[s.FIPS] = s
		})
	}

	stateNameFromFIPS = (geoid) => {
		if (geoid.length >= 2) {
			const st_fips = geoid.substring(0,2)
			if (st_fips in this._fipsLookup)
				return this._fipsLookup[st_fips].StateName
		}
		return null
	}
}

// export access to a singleton instance
export default new AdminBoundsDataManager()
